export default [

     {
          path: '/physical-course-grade',
          name: 'PhysicalCourseGrade',
          component: () => import("@/views/Page/PhysicalCourseGrade/PhysicalCourseGrade.vue"),
           meta: {
               title: 'Cyber Mode | PhysicalCourseGrade',
          },
     }
];